import React from "react";
import {
  Heading,
  InputGroup,
  InputLeftElement,
  Input,
  Checkbox,
  Stack,
  Text,
  HStack,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";

class FreeTrialModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      delay: props.delay || 4,
    };
  }

  getValue = () => {
    return {
      type: "free-trial-modal",
      props: this.state,
    };
  };

  validate = () => {
    return (
      (!!this.state.delay || this.state.delay === 0) && this.state.delay > -1
    );
  };

  render = () => {
    return (
      <div>
        <Heading size="lg" mb={5} data-cy="free-trial-component">
          Free Trial Modal
        </Heading>
        <Stack mb={8} data-cy="form-field-inputs">
          <Text mb={0} fontWeight={"bold"}>
            Form Fields
          </Text>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="text"
              placeholder="First Name"
              data-cy="form-field-input"
            />
          </InputGroup>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="text"
              placeholder="Last Name"
              data-cy="form-field-input"
            />
          </InputGroup>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="email"
              placeholder="Email"
              data-cy="form-field-input"
            />
          </InputGroup>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="industry"
              placeholder="Industry"
              data-cy="form-field-input"
            />
          </InputGroup>
        </Stack>

        <Stack>
          <HStack>
            <Text mb={0} fontWeight={"bold"}>
              Delay
            </Text>
            <Text mb={0} color={"grey"}>
              (seconds)
            </Text>
          </HStack>

          <NumberInput
            defaultValue={this.state.delay}
            min={0}
            onChange={(e) => {
              this.setState({
                delay: parseInt(e),
              });
            }}
          >
            <NumberInputField type="number" />
          </NumberInput>
          <Text fontSize="xs" color={"grey"} mt={0}>
            The length of time it takes for the modal to show, in seconds.
            Positive numbers only.
          </Text>
        </Stack>
      </div>
    );
  };
}

export default FreeTrialModal;
